import { render, staticRenderFns } from "./MemcyCo.vue?vue&type=template&id=5102dce8&"
import script from "./MemcyCo.vue?vue&type=script&lang=js&"
export * from "./MemcyCo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports